export interface WalkedFile {
  file: File;
  relativePath: string;
  folderPath: string;
}

/** From an <input type="file" webkitdirectory> change event. */
export function fromFileList(files: FileList): WalkedFile[] {
  const out: WalkedFile[] = [];
  for (let i = 0; i < files.length; i++) {
    const f = files[i]!;
    const rel = (f as File & { webkitRelativePath?: string }).webkitRelativePath ?? f.name;
    const folderPath = rel.includes('/') ? rel.slice(0, rel.lastIndexOf('/')) : '';
    out.push({ file: f, relativePath: rel, folderPath });
  }
  return out;
}

/** From a drop event's dataTransfer.items. Recursively walks directory entries. */
export async function fromDataTransfer(items: DataTransferItemList): Promise<WalkedFile[]> {
  const entries: FileSystemEntry[] = [];
  for (let i = 0; i < items.length; i++) {
    const it = items[i]!;
    const entry = (it as DataTransferItem & { webkitGetAsEntry?: () => FileSystemEntry | null }).webkitGetAsEntry?.();
    if (entry) entries.push(entry);
  }
  const out: WalkedFile[] = [];
  for (const e of entries) await walk(e, '', out);
  return out;
}

async function walk(entry: FileSystemEntry, prefix: string, out: WalkedFile[]): Promise<void> {
  if (entry.isFile) {
    const file = await new Promise<File>((resolve, reject) =>
      (entry as FileSystemFileEntry).file(resolve, reject),
    );
    const rel = prefix ? `${prefix}/${entry.name}` : entry.name;
    out.push({ file, relativePath: rel, folderPath: prefix });
    return;
  }
  if (entry.isDirectory) {
    const reader = (entry as FileSystemDirectoryEntry).createReader();
    const all: FileSystemEntry[] = [];
    while (true) {
      const batch = await new Promise<FileSystemEntry[]>((resolve, reject) =>
        reader.readEntries(resolve, reject),
      );
      if (batch.length === 0) break;
      all.push(...batch);
    }
    const next = prefix ? `${prefix}/${entry.name}` : entry.name;
    for (const c of all) await walk(c, next, out);
  }
}
